import { createRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Eye, EyeOff } from "lucide-react";
import { rootRoute } from "./__root";
import { api } from "../lib/api";
import styles from "./Login.module.css";

export const route = createRoute({
	getParentRoute: () => rootRoute,
	path: "/login",
	component: LoginPage,
});

function LoginPage() {
	const { t } = useTranslation();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError("");
		setLoading(true);
		try {
			await api.post("/auth/login", { email, password });
			window.location.href = "/";
		} catch (err) {
			setError(err instanceof Error ? err.message : t("loginFailed"));
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={styles.container}>
			<form className={styles.form} onSubmit={handleSubmit}>
				<h1 className={styles.heading}>{t("login")}</h1>
				{error && <div className={styles.error}>{error}</div>}
				<div>
					<label htmlFor="email">{t("email")}</label>
					<input
						id="email"
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						required
					/>
				</div>
				<div>
					<label htmlFor="password">{t("password")}</label>
					<div className={styles.passwordWrapper}>
						<input
							id="password"
							type={showPassword ? "text" : "password"}
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required
							className={styles.passwordInput}
						/>
						<button
							type="button"
							className={styles.passwordToggle}
							onClick={() => setShowPassword((s) => !s)}
							tabIndex={-1}
						>
							{showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
						</button>
					</div>
				</div>
				<button type="submit" className={styles.submit} disabled={loading}>
					{loading ? t("loggingIn") : t("login")}
				</button>
			</form>
		</div>
	);
}
